import 'bootstrap/dist/css/bootstrap.css';
//import * as React from 'react';
//import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './Redux/store';
import ReactDOM from "react-dom/client";
import React from "react";
import { initDellMetrics } from './telemetry/initDellMetrics';
//ReactDOM.render(
//    <Provider store={store}>
//        <App />
//    </Provider>,
//    document.getElementById('root'));



initDellMetrics();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
